
<!-- For Image -->
<div fxLayout="row" fxLayoutAlign="start center" style="width: 100%; height: 30px; display: flex; align-items: center;">
    <img *ngIf="icon" [src]="icon" [alt]="title" style="margin-right: 8px; width: 24px;">
    <h2 style="display: inline-block; margin: 0;color: #0C7BB8;font-weight: bold;font-size: 18px">{{ title }}</h2>
</div>

<div fxLayout="row wrap" fxLayoutAlign="start center" style="display: flex; align-items: center;">
    <label style="margin: 0;">{{ breadcrumb }}</label>
</div>
